import { useState } from "react";
import { fcmApi } from "../../services/Api";
import * as R from "ramda";

export const getFcmAfterLoad = () => {
  const [state, setState] = useState(false);

  const getClientFcmById = async (clientId) => {
    const response = await fcmApi.getFcmsByClientId(clientId);

    if (response.ok && R.isEmpty(response.data)) {
      setState("Cliente ainda sem aparelho registrado para notificação");
    } else {
      setState(null);
    }
  };

  return {
    state: state,
    getClientFcmById,
  };
};
